import { render, staticRenderFns } from "./PostsByRowList.vue?vue&type=template&id=2e03e980&scoped=true"
import script from "./PostsByRowList.vue?vue&type=script&lang=ts"
export * from "./PostsByRowList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e03e980",
  null
  
)

export default component.exports